import { Component } from "@angular/core";

/**
 * Layout mínimo para /error y /no-permissions: SIN MsalGuard ni AuthGuard
 * (evita bucles: si la sesión está rota, la página de error debe poder
 * renderizar sin depender de auth ni del perfil). Patrón infoagua.
 */
@Component({
	selector: "app-error-layout",
	template: `<div class="error-layout-wrapper"><router-outlet></router-outlet></div>`,
	styles: [
		`
			.error-layout-wrapper {
				width: 100%;
				min-height: 100vh;
				display: flex;
				align-items: center;
				justify-content: center;
			}
		`,
	],
	standalone: false,
})
export class ErrorLayoutComponent {}
